import { all, call, takeLatest } from 'redux-saga/effects';
import { getDashInfo } from '../../api/dashboard';
import { DASHBOARD_ACTION_TYPES } from '../actions/dashboard.actions';

function* loadDashboard({ payload, resolve, reject }) {
  try {
    const { data } = yield call(getDashInfo, payload);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* loadDashboardPeriod({ payload, resolve, reject }) {
  try {
    const { data } = yield call(getDashInfo, payload);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* watchDashboard() {
  yield  takeLatest(DASHBOARD_ACTION_TYPES.LOAD_DASHBOARD_INFO, loadDashboard);
}

function* watchDashboardPeriod() {
  yield takeLatest(DASHBOARD_ACTION_TYPES.LOAD_DASHBOARD_INFO_PERIOD, loadDashboardPeriod);
}

export default function* () {
  yield all([
    watchDashboard(),
    watchDashboardPeriod(),
  ]);
}